// src/components/DataTable.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const DataTable = ({ title, newButtonRoute, data, onUpdate }) => {
  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState(8);
  const [selectedVisita, setSelectedVisita] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // Modal de exclusão
  const [editVisita, setEditVisita] = useState(null);

  const handleSearchChange = (e) => setSearch(e.target.value);
  const handleEntriesChange = (e) => setEntries(e.target.value);

  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const filteredData = data.filter((item) =>
    item.tipo_solicitacao_beneficiario_visita.toLowerCase().includes(search.toLowerCase())
  );

  const handleView = (visita) => {
    setSelectedVisita(visita);
    setShowViewModal(true);
  };

  const handleEdit = (visita) => {
    setEditVisita({ ...visita });
    setShowEditModal(true);
  };

  const handleDelete = (visita) => {
    setSelectedVisita(visita);
    setShowDeleteModal(true); // Exibe o modal de exclusão
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}visitas/${selectedVisita.id}/`, {
        method: "DELETE",
      });

      if (response.ok) {
        console.log("Visita excluída com sucesso!");
        setShowDeleteModal(false); // Fecha o modal após exclusão
        if (typeof onUpdate === "function") {
          onUpdate(); // Atualiza os dados
        }
      } else {
        console.error("Erro ao excluir o registro.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  const handleCloseView = () => setShowViewModal(false);
  const handleCloseEdit = () => setShowEditModal(false);
  const handleCloseDelete = () => setShowDeleteModal(false);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
  
    let formattedValue = value;
    
    if (name === "cpf_beneficiario_visita") {
      formattedValue = formatCPF(value);
    }
    if (name === "renda_beneficiario_visita") {
      formattedValue = formatValor(value);
    }
    if (name === "telefone_beneficiario_visita") {
      formattedValue = formatTelefone(value);
    }
    if (name === "data_nascimento_beneficiario_visita" || name === "data_visita_beneficiario_visita") {
      formattedValue = formatData(value);
    }
    if (name === "hora_visita_beneficiario_visita") {
      formattedValue = formatHora(value);
    }
    
    setEditVisita({
      ...editVisita,
      [name]: formattedValue,
    });
  };

  const handleEditSubmit = async () => {
    try {
      const response = await fetch(`http://localhost:8000/api/visitas/${editVisita.id}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editVisita),
      });

      if (response.ok) {
        console.log("Visita atualizada com sucesso!");
        setShowEditModal(false);
        if (typeof onUpdate === "function") {
          onUpdate(); // Atualiza os dados
        }
      } else {
        console.error("Erro ao atualizar o registro.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  const formatTelefone = (value) => {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);

    if (value.length <= 10) {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2");
    } else {
      return value
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2");
    }
  };

 // Formats a date input (assumed digits only) into DD/MM/YYYY as the user types
const formatData = (value) => {
  // Remove non-digit characters and limit to 8 digits (DDMMYYYY)
  const digits = value.replace(/\D/g, "").substring(0, 8);
  let formatted = digits;
  if (digits.length >= 3) {
    formatted = digits.substring(0, 2) + "/" + digits.substring(2, 4);
  }
  if (digits.length >= 5) {
    formatted += "/" + digits.substring(4, 8);
  }
  return formatted;
};

// Formats a time input (assumed digits only) into HH:MM:SS as the user types
const formatHora = (value) => {
  // Remove non-digit characters and limit to 6 digits (HHMMSS)
  const digits = value.replace(/\D/g, "").substring(0, 6);
  let formatted = digits;
  if (digits.length >= 3) {
    formatted = digits.substring(0, 2) + ":" + digits.substring(2, 4);
  }
  return formatted;
};

const formatValor = (value) => {
  value = value.replace(/\D/g, "");
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value / 100);
};

// Formats a CPF number into the mask 000.000.000-00
const formatCPF = (value) => {
  // Remove non-digits and limit to 11 digits
  const digits = value.replace(/\D/g, "").substring(0, 11);
  let formatted = digits;
  if (digits.length > 3) {
    formatted = digits.substring(0, 3) + "." + digits.substring(3);
  }
  if (digits.length > 6) {
    // After inserting the first dot, the second dot should be inserted at position 7
    formatted = formatted.substring(0, 7) + "." + formatted.substring(7);
  }
  if (digits.length > 9) {
    // After dots, the dash is inserted at position 11
    formatted = formatted.substring(0, 11) + "-" + formatted.substring(11);
  }
  return formatted;
};

const safeValue = (value) => {
  if (value == null || (typeof value === "string" && value.trim() === "")) {
    return "-";
  }
  return value;
};

const formatSafeDate = (dateString) => {
  return dateString ? formatDate(dateString) : "-";
};

const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className="card-title">{title}</h3>
        <div className="btn-list">
          <NavLink to={newButtonRoute} className="btn btn-primary d-flex align-items-center">
            <span className="ms-1">Novo</span>
          </NavLink>
        </div>
      </div>

      <div className="card-body border-bottom py-3">
        <div className="d-flex">
          <div className="text-secondary">
            Mostrar
            <div className="mx-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={entries}
                onChange={handleEntriesChange}
                size="3"
                aria-label="Contador de registros"
              />
            </div>
            registros
          </div>
          <div className="ms-auto text-secondary">
            Procurar:
            <div className="ms-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={search}
                onChange={handleSearchChange}
                aria-label="Procurar"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table card-table table-vcenter text-nowrap datatable">
          <thead>
            <tr>
              <th className="w-1">
                <input
                  className="form-check-input m-0 align-middle"
                  type="checkbox"
                  aria-label="Selecionar todos os registros"
                />
              </th>
              <th className="w-1">CPF</th>
              <th>Nome Beneficiário</th>
              <th>Pedido</th>
              <th>Urgência</th>
              <th>Data da Visita</th>
              <th>Status do Pedido</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.slice(0, entries).map((item) => (
                <tr key={item.id}>
                  <td>
                    <input
                      className="form-check-input m-0 align-middle"
                      type="checkbox"
                      aria-label="Select invoice"
                    />
                  </td>
                  <td><span className="text-secondary">{safeValue(item.cpf_beneficiario_visita)}</span></td>
                  <td>{safeValue(truncateText(item.nome_beneficiario_visita, 20))}</td>
                  <td>{safeValue(truncateText(item.tipo_solicitacao_beneficiario_visita, 30))}</td>
                  <td>{safeValue(truncateText(item.urgencia_beneficiario_visita, 30))}</td>
                  <td>{safeValue(formatSafeDate(item.data_visita_beneficiario_visita))}</td>
                  <td>
                    <span className={`badge ${item.pedido_beneficiario_visita === "atendido" ? "bg-success" : "bg-danger"} me-1`}></span>
                    {item.pedido_beneficiario_visita === "atendido" ? "Atendido": "Não Atendido"}
                  </td>
                  <td className="text-end">
                    <span className="dropdown">
                      <button className="btn dropdown-toggle align-text-top" data-bs-toggle="dropdown">Ações</button>
                      <div className="dropdown-menu dropdown-menu-end">
                        <button className="dropdown-item" onClick={() => handleView(item)}>Ver</button>
                        <button className="dropdown-item" onClick={() => handleEdit(item)}>Editar</button>
                        <button className="dropdown-item text-red" onClick={() => handleDelete(item)}>Excluir</button>
                      </div>
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center text-muted">
                  Não existem visitas cadastradas
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="card-footer d-flex align-items-center">
        <p className="m-0 text-secondary">
          Exibindo <span>1</span> até <span>{Math.min(entries, filteredData.length)}</span> de <span>{filteredData.length}</span> registros
        </p>
        <ul className="pagination m-0 ms-auto">
          <li className="page-item disabled">
            <a className="page-link" href="#" aria-disabled="true">ante</a>
          </li>
          {/* Pagination items */}
          <li className="page-item active">
            <a className="page-link" href="#">1</a>
          </li>
          <li className="page-item"><a className="page-link" href="#">2</a></li>
          <li className="page-item"><a className="page-link" href="#">3</a></li>
          <li className="page-item">
            <a className="page-link" href="#">prox</a>
          </li>
        </ul>
      </div>
      
      {/* Modal para visualização da Visita */}
      <Modal show={showViewModal} onHide={handleCloseView}>
        <Modal.Header closeButton>
          <Modal.Title>Detalhes da Visita</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedVisita ? (
            <div>
              <h4 className="mt-1">1. Informações do Beneficiário</h4>
              <div>
                <div class="text-reset d-block mt-2"><strong>CPF Beneficiário</strong></div> <div class="d-block text-secondary text-truncate mt-n1">{safeValue(selectedVisita.cpf_beneficiario_visita)}</div>
                <div class="text-reset d-block mt-2"><strong>Nome Beneficiário</strong></div> <div class="d-block text-secondary text-truncate mt-n1">{safeValue(selectedVisita.nome_beneficiario_visita)}</div>
                <div class="text-reset d-block mt-2"><strong>Data Nascimento</strong></div> <div class="d-block text-secondary text-truncate mt-n1">{formatSafeDate(selectedVisita.data_nascimento_beneficiario_visita)}</div>
                <div class="text-reset d-block mt-2"><strong>Endereço</strong></div> <div class="d-block text-secondary text-truncate mt-n1">{safeValue(selectedVisita.endereco_beneficiario_visita)}</div>
                <div class="text-reset d-block mt-2"><strong>Bairro</strong></div> <div class="d-block text-secondary text-truncate mt-n1">{safeValue(selectedVisita.bairro_endereco_beneficiario_visita)}</div>
                <div class="text-reset d-block mt-2"><strong>Telefone</strong></div> <div class="d-block text-secondary text-truncate mt-n1">{safeValue(formatTelefone(selectedVisita.telefone_beneficiario_visita))}</div>
              </div>
              <h4 className="mt-4">2. Composição Familiar</h4>
                <div class="text-reset d-block mt-2"><strong>Número de Membros</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.numero_membros_beneficiario_visita)}</div>
                <div class="text-reset d-block mt-2"><strong>Renda</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.renda_beneficiario_visita)}</div>
                <div class="text-reset d-block mt-2"><strong>Ocupação</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.ocupacao_beneficiario_visita)}</div>
                <div class="text-reset d-block mt-2"><strong>Habitacão</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.habitacao_beneficiario_visita)}</div>
                <div class="text-reset d-block mt-2"><strong>Escolaridade</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.escolaridade_beneficiario_visita)}</div>
              <h4 className="mt-4">3. Informações da Solicitação</h4>
              <div class="text-reset d-block mt-2"><strong>Tipo Solicitação</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.tipo_solicitacao_beneficiario_visita)}</div>
              <div class="text-reset d-block mt-2"><strong>Necessidade</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.necessidade_beneficiario_visita)}</div>
              <div class="text-reset d-block mt-2"><strong>Urgência</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.urgencia_beneficiario_visita)}</div>
              <div class="text-reset d-block mt-2"><strong>Data Visita</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {formatSafeDate(selectedVisita.data_visita_beneficiario_visita)}</div>
              <div class="text-reset d-block mt-2"><strong>Hora Visita</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {formatSafeDate(selectedVisita.hora_visita_beneficiario_visita)}</div>
              <div class="text-reset d-block mt-2"><strong>Responsável Visita</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.responsavel_visita_beneficiario_visita)}</div>
              <h4 className="mt-4">4. Informações da Atendimento</h4>
              <div class="text-reset d-block mt-2"><strong>Quantidade</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.quantidade_atendido)}</div>
              <div class="text-reset d-block mt-2"><strong>Descrição do Item</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.descricao_item_atendido)}</div>
              <div class="text-reset d-block mt-2"><strong>Pedido</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {capitalizeFirstLetter(selectedVisita.pedido_beneficiario_visita)}</div>
              <div class="text-reset d-block mt-2"><strong>Observação</strong></div> <div class="d-block text-secondary text-truncate mt-n1"> {safeValue(selectedVisita.observacao_beneficiario_visita)}</div>
            </div>
          ) : (
            <p>Carregando...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseView}>Fechar</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de exclusão */}
      <Modal show={showDeleteModal} onHide={handleCloseDelete}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza de que deseja excluir a visita <strong>{selectedVisita?.nome_beneficiario_visita}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDelete}>Cancelar</Button>
          <Button variant="danger" onClick={confirmDelete}>Excluir</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para edição da Visita */}
      <Modal show={showEditModal} onHide={handleCloseEdit}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Visita</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editVisita ? (
            <form>
              <div className="mb-3">
                <label className="form-label">CPF Beneficiário</label>
                <input
                  type="text"
                  className="form-control"
                  name="cpf_beneficiario_visita"
                  value={editVisita.cpf_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Nome Beneficiário</label>
                <input
                  type="text"
                  className="form-control"
                  name="nome_beneficiario_visita"
                  value={editVisita.nome_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Data Nascimento</label>
                <input
                  type="text"
                  className="form-control"
                  name="data_nascimento_beneficiario_visita"
                  value={editVisita.data_nascimento_beneficiario_visita}
                  onChange={handleEditChange}
                  placeholder="DD/MM/YYYY"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Endereço</label>
                <input
                  type="text"
                  className="form-control"
                  name="endereco_beneficiario_visita"
                  value={editVisita.endereco_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Bairro</label>
                <input
                  type="text"
                  className="form-control"
                  name="bairro_endereco_beneficiario_visita"
                  value={editVisita.bairro_endereco_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Telefone</label>
                <input
                  type="text"
                  className="form-control"
                  name="telefone_beneficiario_visita"
                  value={editVisita.telefone_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Número de Membros</label>
                <input
                  type="text"
                  className="form-control"
                  name="numero_membros_beneficiario_visita"
                  value={editVisita.numero_membros_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Renda</label>
                <input
                  type="text"
                  className="form-control"
                  name="renda_beneficiario_visita"
                  value={editVisita.renda_beneficiario_visita}
                  onChange={handleEditChange}
                  placeholder="R$ 0,00"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Ocupação</label>
                <input
                  type="text"
                  className="form-control"
                  name="ocupacao_beneficiario_visita"
                  value={editVisita.ocupacao_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Habitacão</label>
                <input
                  type="text"
                  className="form-control"
                  name="habitacao_beneficiario_visita"
                  value={editVisita.habitacao_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Escolaridade</label>
                <input
                  type="text"
                  className="form-control"
                  name="escolaridade_beneficiario_visita"
                  value={editVisita.escolaridade_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Tipo Solicitação</label>
                <input
                  type="text"
                  className="form-control"
                  name="tipo_solicitacao_beneficiario_visita"
                  value={editVisita.tipo_solicitacao_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Necessidade</label>
                <input
                  type="text"
                  className="form-control"
                  name="necessidade_beneficiario_visita"
                  value={editVisita.necessidade_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Urgência</label>
                <input
                  type="text"
                  className="form-control"
                  name="urgencia_beneficiario_visita"
                  value={editVisita.urgencia_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Data Visita</label>
                <input
                  type="text"
                  className="form-control"
                  name="data_visita_beneficiario_visita"
                  value={editVisita.data_visita_beneficiario_visita}
                  onChange={handleEditChange}
                  placeholder="DD/MM/YYYY"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Hora Visita</label>
                <input
                  type="text"
                  className="form-control"
                  name="hora_visita_beneficiario_visita"
                  value={editVisita.hora_visita_beneficiario_visita}
                  onChange={handleEditChange}
                  placeholder="HH:MM"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Responsável Visita</label>
                <input
                  type="text"
                  className="form-control"
                  name="responsavel_visita_beneficiario_visita"
                  value={editVisita.responsavel_visita_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Pedido</label>
                <input
                  type="text"
                  className="form-control"
                  name="pedido_beneficiario_visita"
                  value={editVisita.pedido_beneficiario_visita}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Observação</label>
                <textarea
                  className="form-control"
                  name="observacao_beneficiario_visita"
                  value={editVisita.observacao_beneficiario_visita}
                  onChange={handleEditChange}
                ></textarea>
              </div>
            </form>
          ) : (
            <p>Carregando...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEdit}>Cancelar</Button>
          <Button variant="primary" onClick={handleEditSubmit}>Salvar</Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default DataTable;